<template>
  <!-- 09.28 팝업추가 -->
  <v-dialog
    v-model="addTemplateVisible"
    width="400"
    @click:outside="cancelAddTemplate"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="addBtnDisabled"
        text
        v-bind="attrs"
        v-on="on"
        class="btn"
        >{{ $t('New') }}</v-btn
      >
    </template>
    <v-card class="popup add_store_popup" :key="addTemplateVisible">
      <h3 class="page-title-bar">
        <i class="ico ico-template"></i>{{ $t('New Template Type') }}
      </h3>
       <v-row>
        <v-col class="pt-0">
          <v-text-field
            v-model="template.typeName"
            outlined
            dense
            hide-details
            :label="`${$t('Type Name')} *`"
            :placeholder="`${$t('Input the type name')}`"
            class="form-input"
            clearable
            @keypress="handleKeyUp"
            @keydown="clearTabindex"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <v-select
            outlined
            dense
            hide-details
            v-model="tagType"
            :items="tagTypes"
            :label="`${$t('Template Size')}`"
            :placeholder="`${$t('Input the template Size')}`"
            class="form-select"
            clearable
             @keydown="clearTabindex"
          ></v-select>
        </v-col>
      </v-row>
      <v-card-actions class="d-flex justify-center">
        <v-btn text icon @click="addTemplate" class="btn">{{
          $t('Save')
        }}</v-btn>
        <v-btn text icon @click="cancelAddTemplate" class="btn">{{
          $t('Cancel')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/plugins/eventBus.js'
import commons from '@/plugins/commons'

const requests = {
  getTagTypes: {
    method: 'get',
    url: '/api/common/templates/data'
  },
  addTemplate: {
    method: 'post',
    url: '/api/common/templates/type'
  }
}

export default {
  props: ['user', 'addBtnDisabled'],
  data () {
    return {
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      addTemplateVisible: false,
      addTemplateInputKey: true,
      template: {
        typeName: null,
        templateSize: null
      },
      tagType: null,
      tagTypes: [],
      sizesByTagTypes: []
    }
  },
  methods: {
    handleKeyUp (e) {
      commons.specialCharRest(e)
    },
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    cancelAddTemplate () {
      this.addTemplateVisible = false
      this.template = {
        typeName: null,
        templateSize: null
      }
      this.tagType = null
    },
    setSizesByTagTypes (tagTypeList) {
      const sizesByTagTypes = {}
      for (const tagType of tagTypeList) {
        sizesByTagTypes[tagType.name] = tagType
      }
      this.sizesByTagTypes = sizesByTagTypes
    },
    getTagTypes () {
      const params = { company: this.user.company }
      const config = { params: params }

      this.$utils
        .callAxios(
          requests.getTagTypes.method,
          requests.getTagTypes.url,
          config
        )
        .then(res => {
          this.setSizesByTagTypes(res.data.tagTypeList)
          this.tagTypes = res.data.tagTypeList.map(tl => tl.name)
        })
    },

    // save template
    addTemplate () {
      this.template.typeName =
        this.template.typeName === null
          ? null
          : this.template.typeName.trim()
      this.template.templateSize = this.tagType
      const template = this.template
      const isValidData = commons.isValidData(template)
      if (!isValidData.result) {
        EventBus.$emit('messageAlert', this.$t(isValidData.msg))
        return
      }
      const params = { company: this.user.company }
      // const config = { params }
      params.company = this.$store.state.auth.user.company

      if (this.productionType === 'cloud') {
        template.labelType = this.tagType
      }
      this.$utils
        .callAxiosWithBody(
          requests.addTemplate.method,
          requests.addTemplate.url,
          template

        )
        .then(res => {
          const result = res.data
          EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          this.cancelAddTemplate()
          this.$emit('refreshTemplates')
        })
        .catch(error => {
          const result = error.response.data
          if (error.response.status === 409) {
            EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          } else {
            EventBus.$emit('messageAlert', this.$t('Failed to add new template'))
          }
          // this.cancelAddTemplate()
        })
    }

  },
  computed: {
    tagTypeSelected () {
      return this.tagType !== null
    }
  },
  mounted () {
    this.getTagTypes()
  }
}
</script>

<style></style>
